var swiper = new Swiper('.desk .swiper-points', {
    slidesPerView: 2,
    spaceBetween: 0,
    loop: false,
    a11y: {
      enabled: true,
      slideLabelMessage: ""
    },
    navigation: {
      nextEl: '.desk .swiper-button-next',
      prevEl: '.desk .swiper-button-prev',
    },
    breakpoints: {       
      960: {
        slidesPerView: 3,
        spaceBetween: 0,
        slidesPerGroup: 3,
      }
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
  });
  
  var swiper = new Swiper(".mob-points .swiper-points", {
    centeredSlides: true,
    slidesPerView: 1.5,
    slidesPerGroup: 1,
  })
  var swiper = new Swiper('.mob-bedding .swiper-bedding', {
    slidesPerView: 1.5,
    spaceBetween: 30,
    loop: false,
    a11y: {
      enabled: true,
      slideLabelMessage: ""
    }
  });
  var swiper = new Swiper('.item-image .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow:true,
    a11y: {
      enabled: true,
      slideLabelMessage: ""
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
  });
  